import { requireConnection } from "./connection";
// かめ (Kame) - the in-app AI study assistant. Requires a signed-in Cognito
// session (the backend verifies the ID token and enforces a small per-user
// daily limit, since each call has a real per-request cost) - see
// infra/lambda/assistant-chat/index.mjs.
const PUBLIC_API_URL = "https://d29a52ery9.execute-api.us-east-1.amazonaws.com/prod";
const ASSISTANT_CHAT_URL = `${PUBLIC_API_URL}/assistant/chat`;

export interface AssistantMessage {
    role: "user" | "assistant";
    content: string;
}

// Distinct from a generic failure so the widget can show an in-character
// "come back tomorrow" message instead of a raw error.
export class AssistantQuotaError extends Error {
    constructor() {
        super("Daily assistant message limit reached");
        this.name = "AssistantQuotaError";
    }
}

export async function sendAssistantMessage(messages: AssistantMessage[], idToken: string): Promise<string> {
    requireConnection();
    const response = await fetch(ASSISTANT_CHAT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
        body: JSON.stringify({ messages: messages.slice(-12) }),
    });

    if (response.status === 429) throw new AssistantQuotaError();
    if (!response.ok) throw new Error(`Assistant request failed (${response.status})`);

    const data = await response.json();
    if (typeof data.reply !== "string") throw new Error("Malformed assistant response");

    return data.reply;
}
